var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "love",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_809",
    "data-name": "Ellipse 809",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffd93b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_37773",
    "data-name": "Path 37773",
    d: "M110.073,80.073A30,30,0,0,1,56.72,98.907,30,30,0,0,0,98.907,56.72,29.968,29.968,0,0,1,110.073,80.073Z",
    transform: "translate(-50.073 -50.073)",
    fill: "#f4c534"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37774",
    "data-name": "Path 37774",
    d: "M101.063,167.777c0,5.764-8.707,11.036-8.707,11.036s-8.707-5.273-8.707-11.036a4.455,4.455,0,0,1,8.713-1.305,4.449,4.449,0,0,1,8.7,1.305Z",
    transform: "translate(-73.845 -144.188)",
    fill: "#e24b4b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37775",
    "data-name": "Path 37775",
    d: "M85.126,173.312a4.417,4.417,0,0,0-1.462,3.281c0,5.764,8.708,11.036,8.708,11.036C83.253,179.929,85.059,173.535,85.126,173.312Z",
    transform: "translate(-73.86 -153.002)",
    fill: "#d03f3f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37776",
    "data-name": "Path 37776",
    d: "M199.948,182.82c-.424.343-1.144.114-1.616-.489-.489-.6-.54-1.339-.146-1.65.424-.326,1.144-.083,1.633.523C200.291,181.806,200.356,182.541,199.948,182.82Z",
    transform: "translate(-174.729 -159.379)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37777",
    "data-name": "Path 37777",
    d: "M297.159,167.777c0,5.764-8.707,11.036-8.707,11.036s-8.707-5.273-8.707-11.036a4.455,4.455,0,0,1,8.713-1.305,4.449,4.449,0,0,1,8.7,1.305Z",
    transform: "translate(-246.961 -144.188)",
    fill: "#e24b4b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37778",
    "data-name": "Path 37778",
    d: "M281.223,173.312a4.417,4.417,0,0,0-1.463,3.281c0,5.764,8.707,11.036,8.707,11.036C279.349,179.929,281.155,173.535,281.223,173.312Z",
    transform: "translate(-246.976 -153.002)",
    fill: "#d03f3f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37779",
    "data-name": "Path 37779",
    d: "M396.044,182.82c-.424.343-1.144.114-1.616-.489-.489-.6-.54-1.339-.146-1.65.424-.326,1.144-.083,1.633.523C396.387,181.806,396.452,182.541,396.044,182.82Z",
    transform: "translate(-347.845 -159.379)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37780",
    "data-name": "Path 37780",
    d: "M155.966,348.595c-3.544,4.2-8.826,7.549-14.732,7.549s-11.181-3.349-14.743-7.53a2.058,2.058,0,0,1,1.931-3.356,73.559,73.559,0,0,0,25.631-.019A2.053,2.053,0,0,1,155.966,348.595Z",
    transform: "translate(-111.232 -304.754)",
    fill: "#3e4347"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_37781",
    "data-name": "Path 37781",
    d: "M197.256,389.131a17.285,17.285,0,0,0,8.4-2.291c-1.065-3.951-4.776-5.076-7.341-3.712-3.474,1.854-7.361-.546-8.861,4.02A17.078,17.078,0,0,0,197.256,389.131Z",
    transform: "translate(-167.254 -337.741)",
    fill: "#e24b4b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.f963b98a055679ae08497f646bdc8e94.svg";
export { ForwardRef as ReactComponent };